<template>
  <div
    v-if="
      loadedMatrixPOI &&
      loadedMatrixAreas &&
      loadedMatrixForVROOM &&
      loadedAllItinararies
    "
  >
    <div class="mt-2">
      <div>
        <div class="row mt-2">
          <div
            class="col-12 pr-0"
            :class="isLarge ? 'div_header' : 'div_header_mobile'"
            v-if="isGeodidalab"
          >
            <i
              class="bi bi-arrow-left ml-3 goBackArrow pt-3"
              v-if="isGeodidalab"
              v-on:click="goBack()"
            ></i>
            <h4><b>Elenco Itinerari</b></h4>
          </div>
          <div v-else class="col-12">
            <h4 class="text-center mt-0">
              <b>Elenco itinerari</b>
            </h4>
          </div>
        </div>

        <div class="mb-4">
          <div class="row mx-0">
            <div class="col-12">
              <h6 class="text-center mt-0">
                Clicca su un itinerario per espanderlo e vederne i dettagli
              </h6>
            </div>
          </div>
        </div>

        <!--ELENCO PERCORSI:-->
        <div
          v-if="
            $store.state.itinerari !== null &&
            mediaLoadedForItinerary.filter((bool) => bool === false).length ===
              0
          "
          class="px-lg-5"
        >
          <article
            class="postcardpercorsi light orange mx-2 overflow-hidden"
            :class="!isLarge ? 'cursor-pointer ' : ''"
            v-for="(itinerario, index) in $store.state.itinerari"
            :key="'itinerario' + index"
          >
            <a class="postcardpercorsi__img_link">
              <img
                class="postcardpercorsi__img"
                v-img="{ group: getGroupName(itinerario) }"
                :src="
                  itinerario.media[0]
                    ? itinerario.media[0]['thumbnail_display_urls']['large']
                    : require('@/assets/images/percorsi.jpg')
                "
                :alt="itinerario['geo:Titolo_it'][0]['@value']"
              />
            </a>
            <div
              class="postcardpercorsi__text"
              v-on:click="
                !isLarge ? goToItinerarioPredefinitoPage(index) : null
              "
            >
              <div class="h-100">
                <h1
                  class="orange"
                  :class="{
                    postcardpercorsi__title: isLarge,
                    postcardpercorsi__title__mobile: !isLarge,
                  }"
                >
                  {{ itinerario["geo:Titolo_it"][0]["@value"] }}
                </h1>

                <div
                  class="postcardpercorsi__preview-txt mb-3"
                  v-if="itinerario['dcterms:description'] !== undefined"
                >
                  {{ itinerario["dcterms:description"][0]["@value"] }}
                </div>
                <div class="postcardpercorsi__preview-txt mb-3" v-else>
                  Nessuna descrizione disponibile
                </div>

                <h6>
                  <template v-if="getInterestList(itinerario['geo:appartiene_a_ambito']).length > 1">Interessi: </template>
                  <template v-else>Interesse: </template>
                  <span class="font-weight-normal">{{
                    getInterestList(itinerario["geo:appartiene_a_ambito"]).join(
                      ", "
                    )
                  }}</span>
                </h6>
              </div>
              <div :class="{ 'text-left': isLarge, 'text-center': !isLarge }">
                <Button
                  size="small"
                  type="primary"
                  v-on:click="
                    isLarge ? goToItinerarioPredefinitoPage(index) : null
                  "
                  class="mt-2 button_font"
                  style="width: fit-content"
                  >Esplora itinerario
                </Button>
              </div>
            </div>
          </article>
        </div>
        <div class="col-12 text-center" v-else>
          <h4 slot="header" class="title title-up text-center">
            Caricamento in corso
          </h4>
          <div class="loader">
            <svg class="circular">
              <circle
                class="path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke-width="5"
                stroke-miterlimit="10"
              ></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <ScrollTopArrow :createItinerary="false"></ScrollTopArrow>
  </div>
</template>

<script>
const Common = require("@/Common.vue").default;
import store from "../store";
import router from "../router";
import $ from "jquery";
import { Button } from "element-ui";
import { config } from "../utils/config";
import GoTop from "@inotom/vue-go-top";
import ScrollTopArrow from "../components/customComponents/ScrollTopArrow";

export default {
  name: "PercorsoSelezionato",
  bodyClass: "percorsi-page",

  components: {
    Button,
    ScrollTopArrow,
  },

  data() {
    return {
      itinerari: null,
      windowWidth: 0,
      isLoadingPOIPivot: true,
      activitiesLoaded: false,
      isLoadingAree: true,
      isGeodidalab: false,
      loadedAllItinararies: false,
      mediaLoadedForItinerary: [false],
    };
  },

  async created() {
    this.$store.commit("removeOtherObjects");
    this.$store.commit("removePOIAndActivities");

    this.isGeodidalab = config.isGeodidalab;

    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    var self = this;

    Common.getElemsByClass(self, config.omekaIDs.omekaIDarea, (res) => {
      store.state.aree = res.body;
      self.isLoadingAree = false;

      //chiedo gli itinerari
      Common.getElemsByClass(self, config.omekaIDs.omekaIDitinerario, (res) => {
        store.state.itinerari = res.body;

        store.state.itinerari.sort(
          (a, b) =>
            a["geo:Posizione_itinerario"][0]["@value"] -
            b["geo:Posizione_itinerario"][0]["@value"]
        );

        self.mediaLoadedForItinerary = new Array(
          store.state.itinerari.length
        ).fill(false);

        Array.prototype.forEach.call(
          store.state.itinerari,
          (itinerario, index) => {
            /*chiedo l'immagine degli itinerari*/
            Common.getElementImages(self, itinerario, (mediaList) => {
              this.$set(itinerario, "media", mediaList);
              self.mediaLoadedForItinerary[index] = true;
            });
          }
        );

        self.loadedAllImages = true;
      });

      self.loadedAllItinararies = true;
    });

    //questo blocco serve per poter invalidare la dimensione della mappa e visualizzarla correttamente essendo in un collapse
    $(document).on("click", "a", function (event) {
      //emit event to child component
      if (
        event.currentTarget.attributes[2] !== undefined &&
        event.currentTarget.attributes[2].value === "#collapseItinerario"
      ) {
        self.$root.$emit("invalidateMapSize");
      }
    });

    $(document).ready(function () {
      $("#collapseItinerario").trigger("click");
    });
  },

  mounted() {
    this.getCostMatricesOmeka();
  },

  methods: {
    getCostMatricesOmeka() {
      Common.getElemsByClass(
        this,
        config.omekaIDs.omekaIDmatriciSpostamenti,
        (res) => {
          store.state.omekaCsvMatrixes = res.body;
          store.commit("initCostMatrixPOI");
          store.commit("initCostMatrixAreas");
        }
      );
    },

    getInterestList(list) {
      var newList = [];

      for (var i = 0; i < list.length; i++) {
        newList.push(list[i]["display_title"]);
      }

      return newList;
    },

    getGroupName(itinerario) {
      return itinerario["geo:Titolo_it"][0]["@value"].replaceAll('"', "");
    },
    goBack() {
      router.go(-1);
    },
    goToItinerarioPredefinitoPage(index) {
      var itinerario = this.$store.state.itinerari[index];

      /*
      store.commit("setItinerarioPredefinito", {
        itinerarioPredefinito: itinerario,
      });*/

      //console.log("itinerario");
      //console.log(itinerario);

      router.push({
        name: "sintesiitinerariopredefinito",
        params: {
          id: itinerario["o:id"],
        },
      });
    },
  },

  computed: {
    isLarge() {
      return this.windowWidth >= 768;
    },
    loadedMatrixPOI() {
      return store.state.vroomCostMatricesTimeBetweenPOI !== null;
    },

    loadedMatrixAreas() {
      return store.state.costMatricesTimeBetweenAreas !== null;
    },

    loadedMatrixForVROOM() {
      return store.state.costMatricesTimeBetweenPOI !== null;
    },
  },
};
</script>

<style>
</style>